import { helpers, useFetch } from '@reveni-io/reveni-ui'

import services from '@/services/services'

const useReturnGroup = ({ storeId, allowsMultiOrderReturns }) => {
  const { data, loading } = useFetch(() => services.getAvailableOrders({ storeId }), {
    doInitialRequest: allowsMultiOrderReturns && localStorage.jwt && storeId,
  })

  return {
    orders: data?.results?.map(order => ({ ...order, line_items: helpers.flattenLineItems(order.line_items) })) || [],
    loading,
  }
}

export default useReturnGroup
